import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { ModalProvider } from './context/ModalContext';
import { ConfigProvider } from './context/ConfigContext';
import { GlobalStyles } from './styles/GlobalStyles';
import Layout from './components/Layout/Layout';
import ProtectedRoute, { AdminRoute } from './components/ProtectedRoute';
import Usuarios from './pages/Usuarios';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import NewClient from './pages/NewClient';
import ClientProfile from './pages/ClientProfile';
import Receipts from './pages/Receipts';
import NewReceipt from './pages/NewReceipt';
import ReceiptDetail from './pages/ReceiptDetail';
import RegisterPayment from './pages/RegisterPayment';
import Alerts from './pages/Alerts';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import ImportarClientes from './pages/ImportarClientes';
import Leads from './pages/Leads';
import NewLead from './pages/NewLead';
import LeadDetail from './pages/LeadDetail';
import Quotes from './pages/Quotes';
import NewQuote from './pages/NewQuote';
import QuoteDetail from './pages/QuoteDetail';
import Pipeline from './pages/Pipeline';
import Inventario from './pages/Inventario';
import NuevoInventarioItem from './pages/NuevoInventarioItem';
import InventarioItemDetail from './pages/InventarioItemDetail';
import Pedidos from './pages/Pedidos';
import NuevoPedido from './pages/NuevoPedido';
import PedidoDetail from './pages/PedidoDetail';
import Difusion from './pages/Difusion';
import Plantillas from './pages/Plantillas';
import MiDia from './pages/MiDia';
import Grupos from './pages/Grupos';
import NuevoGrupo from './pages/NuevoGrupo';
import GrupoDetail from './pages/GrupoDetail';

// Componente interno que tiene acceso al contexto de tema
const AppContent = () => {
  const { theme } = useTheme();
  
  return (
    <StyledThemeProvider theme={theme}>
      <ConfigProvider>
      <ModalProvider>
        <GlobalStyles />
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/registro" element={<Register />} />
            <Route path="/*" element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/clientes" element={<Clients />} />
                    <Route path="/clientes/nuevo" element={<NewClient />} />
                    <Route path="/clientes/:id/editar" element={<NewClient />} />
                    <Route path="/clientes/:id" element={<ClientProfile />} />
                    <Route path="/grupos" element={<Grupos />} />
                    <Route path="/grupos/nuevo" element={<NuevoGrupo />} />
                    <Route path="/grupos/:id" element={<GrupoDetail />} />
                    <Route path="/recibos" element={<Receipts />} />
                    <Route path="/recibos/nuevo" element={<NewReceipt />} />
                    <Route path="/recibos/:id" element={<ReceiptDetail />} />
                    <Route path="/registrar-pago" element={<RegisterPayment />} />
                    <Route path="/alertas" element={<Alerts />} />
                    <Route path="/reportes" element={<Reports />} />
                    <Route path="/configuracion" element={<AdminRoute><Settings /></AdminRoute>} />
                    <Route path="/configuracion/importar-clientes" element={<AdminRoute><ImportarClientes /></AdminRoute>} />
                    <Route path="/usuarios" element={<AdminRoute><Usuarios /></AdminRoute>} />
                    <Route path="/leads" element={<Leads />} />
                    <Route path="/leads/nuevo" element={<NewLead />} />
                    <Route path="/leads/:id" element={<LeadDetail />} />
                    <Route path="/cotizaciones" element={<Quotes />} />
                    <Route path="/cotizaciones/nueva" element={<NewQuote />} />
                    <Route path="/cotizaciones/:id" element={<QuoteDetail />} />
                    <Route path="/pipeline" element={<Pipeline />} />
                    <Route path="/inventario" element={<Inventario />} />
                    <Route path="/inventario/nuevo" element={<NuevoInventarioItem />} />
                    <Route path="/inventario/:id" element={<InventarioItemDetail />} />
                    <Route path="/pedidos" element={<Pedidos />} />
                    <Route path="/pedidos/nuevo" element={<NuevoPedido />} />
                    <Route path="/pedidos/:id" element={<PedidoDetail />} />
                    <Route path="/difusion" element={<Difusion />} />
                    <Route path="/plantillas" element={<AdminRoute><Plantillas /></AdminRoute>} />
                    <Route path="/mi-dia" element={<MiDia />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            } />
          </Routes>
        </Router>
      </ModalProvider>
      </ConfigProvider>
    </StyledThemeProvider>
  );
};

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <AppContent />
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
